import './vendor';
import './helpers';
import './popup';
import {sendForm} from './components/analytics';
import './vendor/validate';
import './vendor/jquery.inputmask.bundle.min';

import Swiper from 'swiper';
// import Inputmask from 'maskedinput';
import AOS from 'aos';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import * as analytics from './components/analytics';

analytics.init();

gsap.registerPlugin(ScrollTrigger);

const heightHeader = $('.header__wrapper').height();

function hamburgerToggle() {
	$('.hamburger').on('click', () => {
		$('.header').toggleClass('open');
		$('body').toggleClass('lock');
	});
}

function validate() {
	if ($('#js-form').length) {
		$('#js-form').validate({
			rules: {
				website: {
					required: true,
				},
				name: {
					required: true,
				},
				email: {
					required: true,
					email: true,
				},
				phone: {
					required: true,
					minlength: {
						param: 40,
						depends() {
							return !$('.main-form__input.js-phoneMask').inputmask('isComplete');
						},
					},
				},
			},
			messages: {
				website: {
					required: 'This field is required',
				},
				name: {
					required: 'This field is required',
				},
				email: {
					required: 'This field is required',
					email: 'Invalid E-mail',
				},
				phone: {
					required: 'This field is required',
					minlength: 'This field is required',
				},

			},
			submitHandler() {
				// form.submit();
				sendForm();
				$('.js-show-popupSuccess').get(0).click();
			},
		});
	}
}

function percentToPixel(_elem, _perc) {
	return _elem.parent().outerWidth() / 100 * parseFloat(_perc);
}

function inputTextAnimation(className) {
	let $demoText = $(className);
	$demoText.html($demoText.html().replace(/./g, '<span>$&</span>').replace(/\s/g, '&nbsp;'));
	$demoText.addClass('opacity');
}

function widgetGsapBlock1() {
	let tl = gsap.timeline({
		delay: 1.5,
		repeat: -1,
		repeatDelay: 1,
	});

	inputTextAnimation('.customHeight-5 .scene-form__input-text.animText-1');
	inputTextAnimation('.customHeight-5 .scene-form__input-text.animText-2');
	inputTextAnimation('.customHeight-5 .scene-form__input-text.animText-5');
	inputTextAnimation('.customHeight-5 .scene-form__input-text.animText-6');
	$('.scene-form__input-text.animText-4').addClass('opacity');

	tl.set('.customHeight-5 .sdk__panel-bottom-click.el-1', {
		duration: 0.3,
		ease: 'power1',
		css: {
			animationName: 'click_btn',
		},
		delay: 0.8,
	})
		.set('.customHeight-5 .scene-5 .scene-content__btn', {
			backgroundColor: '#185ae0',
			duration: 0.3,
			ease: 'power1',
			transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
		})
		.to('.customHeight-5 .phone-scene.scene-5 .cross-1-wrapper', {
			rotate: '120deg',
			x: '-8em',
			y: '2em',
			duration: 0.7,
			delay: 0.5,
			ease: 'power1',
		}, 'anim1')
		.to('.customHeight-5 .phone-scene.scene-5 .cross-1-wrapper .cross-1', {
			scale: 0,
			rotate: '-120deg',
			duration: 0.7,
			delay: 0.5,
			ease: 'power1',
		}, 'anim1')
		.to('.customHeight-5 .phone-scene.scene-5 .basket.basket--added', {
			opacity: 1,
			duration: 0.7,
			delay: 0.5,
			ease: 'power1',
		}, 'anim1')
		.set('.customHeight-5 .phone-scene.scene-1', {
			opacity: 1,
			duration: 0.3,
			ease: 'power1',
			delay: 0.5,
			transition: 'opacity 0.3s ease-in-out',
		})
		.set('.customHeight-5 .sdk__panel-bottom-click.el-2', {
			duration: 0.3,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
			delay: 0.8,
		})
		.to('.customHeight-5 .phone-scene.scene-1 .scene-content__btn', {
			backgroundColor: '#185ae0',
			borderColor: '#185ae0',
			duration: 0.1,
			ease: 'power1',
			delay: 0.1,
			transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
		})
		.to('.customHeight-5 .phone-scene.scene-2', {
			opacity: 1,
			ease: 'power1',
			duration: 0.7,
			delay: 0.2,
		}, 'anim10')
		.set('.customHeight-5 .phone-scene.scene-5', {
			opacity: 0,
			ease: 'power1',
			duration: 0.7,
			delay: 0.2,
		}, 'anim10')
		.set('.customHeight-5 .phone-scene.scene-1', {
			opacity: 0,
			ease: 'power1',
			duration: 0.7,
			delay: 0.2,
		}, 'anim10')
		.fromTo($('.customHeight-5 .scene-form__input-text.animText-1').find('span'), {
			autoAlpha: 0,
			scale: 1,
			duration: 0.09,
			stagger: 0.04,
		}, {
			autoAlpha: 1,
			scale: 1,
			duration: 0.05,
			stagger: 0.04,
		})
		.to('.customHeight-5 .sdk-payment__masterCard', {
			duration: 0.3,
			ease: 'power1',
			opacity: 1,
		})
		.fromTo($('.customHeight-5 .scene-form__input-text.animText-5').find('span'), {
			autoAlpha: 0,
			scale: 1,
			duration: 0.09,
			stagger: 0.04,
		}, {
			autoAlpha: 1,
			scale: 1,
			duration: 0.05,
			stagger: 0.04,
		})
		.to('.customHeight-5 .sdk-payment__tinkoff', {
			duration: 0.3,
			ease: 'power1',
			opacity: 1,
		})
		.fromTo($('.customHeight-5 .scene-form__input-text.animText-6').find('span'), {
			autoAlpha: 0,
			scale: 1,
			duration: 0.09,
			stagger: 0.04,
		}, {
			autoAlpha: 1,
			scale: 1,
			duration: 0.05,
			stagger: 0.04,
		})
		.fromTo($('.customHeight-5 .scene-form__input-text.animText-2').find('span'), {
			autoAlpha: 0,
			scale: 1,
			duration: 0.2,
			stagger: 0.06,
		}, {
			autoAlpha: 1,
			scale: 1,
			duration: 0.05,
			stagger: 0.04,
		})
		.fromTo($('.customHeight-5 .scene-form__input-text.animText-4').find('span'), {
			autoAlpha: 0,
			scale: 1,
			duration: 0.09,
			stagger: 0.04,
		}, {
			autoAlpha: 1,
			scale: 1,
			duration: 0.05,
			stagger: 0.04,
		})
		.set('.customHeight-5 .sdk__panel-bottom-click.el-4', {
			duration: 0.3,
			ease: 'power1',
			delay: 0.3,
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-5 .scene-2 .scene-form__btn', {
			backgroundColor: '#185ae0',
			duration: 0.1,
			ease: 'power1',
			transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
		})
		.set('.customHeight-5 .scene-2 .scene-form__btn.main-btn .ruble-blue', {
			opacity: '1',
			transition: 'opacity 0.3s ease-in-out 0.3s',
		})
		.set('.customHeight-5 .scene-2 .scene-form__btn.main-btn .ruble', {
			opacity: '0',
			transition: 'opacity 0.3s ease-in-out 0.3s',
		})
		.set($('.customHeight-5 .phone-scene.scene-5'), {
			css: {
				opacity: '0',
			},
		})
		.to('.customHeight-5 .phone-scene.scene-3', {
			x: percentToPixel($('.phone-scene.scene-3'), 0),
			opacity: 1,
			ease: 'power1',
			duration: 0.5,
			delay: 0.6,
		})
		.set('.customHeight-5 .sdk__panel-bottom-click.el-5', {
			duration: 0.3,
			ease: 'power1',
			delay: 0.5,
			css: {
				animationName: 'click_btn',
			},
		})
		.set($('.customHeight-5 .phone-scene.scene-5'), {
			css: {
				transform: 'none',
				transition: 'none',
			},
		})
		.set('.customHeight-5 .phone-scene.scene-5 .cross-1-wrapper', {
			css: {
				transform: 'none',
				opacity: 1,
				transition: 'opacity 0.3s ease-in-out',
			},
		})
		.set($('.customHeight-5 .phone-scene.scene-5 .cross-1'), {
			css: {
				transform: 'none',
			},
		})
		.to('.customHeight-5 .scene-3 .scene-form__btn', {
			backgroundColor: '#185ae0',
			borderColor: '#185ae0',
			duration: 0.1,
			ease: 'power1',
			transition: 'background-color 0.3s ease-in-out 0.3s, border-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
		})
		.set($('.customHeight-5 .phone-scene.scene-5 .scene-content__btn'), {
			css: {
				opacity: 1,
				backgroundColor: '#2e71fc',
				color: '#fff',
				borderColor: '#2e71fc',
				transition: 'none',
			},
		})
		.set($('.customHeight-5 .phone-scene.scene-6'), {
			css: {
				opacity: 1,
				transition: 'opacity 0.3s ease-in-out',
			},
			delay: 0.5,
		});
}

function widgetGsapBlock2() {
	let tl1 = gsap.timeline();

	let start;
	if ($(window).width() > 1023) {
		start = heightHeader * 1.5;
	} else {
		start = heightHeader * 1.2;
	}

	ScrollTrigger.create({
		trigger: '.customHeight-6',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	if ($(window).width() > 1023) {
		tl1.fromTo('.sprite-widget-adaptability-desktop', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.widget-adaptability-desktop__wrapper', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.8,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.widget-adaptability-mobile__wrapper', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			y: percentToPixel($('.customHeight-18 .main-sdk-platform'), -20),
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).to('.customHeight-6 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '50%',
			},
		});
	} else {
		tl1.fromTo('.sprite-widget-adaptability-desktop', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.widget-adaptability-tablet__wrapper', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			css: {
				right: '-40em',
			},
		}, {
			duration: 60,
			opacity: 1,
			ease: 'power1',
			css: {
				right: '-3.5em',
			},
		}).fromTo('.widget-adaptability-mobile__wrapper', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			y: percentToPixel($('.customHeight-18 .main-sdk-platform'), -20),
			duration: 60,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).to('.customHeight-6 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '50%',
			},
		});
	}
}

function widgetGsapBlock3() {
	let tl2 = gsap.timeline();
	let start = heightHeader * 1.5;

	inputTextAnimation('.customHeight-7 .scene-form__input-text.animText-1');
	inputTextAnimation('.customHeight-7 .scene-form__input-text.animText-2');
	inputTextAnimation('.customHeight-7 .scene-form__input-text.animText-5');
	inputTextAnimation('.customHeight-7 .scene-form__input-text.animText-6');
	$('.scene-form__input-text.animText-4').addClass('opacity');

	ScrollTrigger.create({
		trigger: '.customHeight-7',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -1000%',
		scrub: 0.3,
		pin: true,
		animation: tl2,
	});

	if ($(window).width() > 1023) {
		tl2.fromTo('.customHeight-7 .phone-bg', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			y: percentToPixel($('.customHeight-18 .main-sdk-platform'), -30),
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).to('.customHeight-7 ._delay', {
			css: {
				width: '50%',
			},
			duration: 100,
			ease: 'power1',
		})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-1').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '100%',
				},
				duration: 20,
				ease: 'power1',
			})
			.set('.customHeight-7 .sdk-payment__masterCard', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-5').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '50%',
				},
				duration: 20,
				ease: 'power1',
			})
			.set('.customHeight-7 .sdk-payment__tinkoff', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-6').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.to($('.customHeight-7 .line'), {
				opacity: 1,
				duration: 100,
				ease: 'power1',
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-2').find('span'), {
				autoAlpha: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-4').find('span'), {
				autoAlpha: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.customHeight-7 .scene-form__btn.main-btn'), {
				opacity: 0.5,
				duration: 100,
				ease: 'power1',
			}, {
				opacity: 1,
				duration: 100,
				ease: 'power1',
			})
			.set('.customHeight-7 .sdk__panel-bottom-click.el-1', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-7 .scene-2 .scene-form__btn.main-btn', {
				backgroundColor: '#185ae0',
				duration: 100,
				ease: 'power1',
				transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
			})
			.set('.customHeight-7 .scene-2 .scene-form__btn.main-btn .ruble-blue', {
				opacity: '0',
				transition: 'opacity 0.3s ease-in-out 0.3s',
			})
			.set('.customHeight-5 .scene-2 .scene-form__btn.main-btn .ruble', {
				opacity: '1',
				transition: 'opacity 0.3s ease-in-out 0.3s',
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '100%',
				},
				duration: 100,
				ease: 'power1',
			})
			.set('.customHeight-7 .phone-scene.scene-3', {
				x: percentToPixel($('.phone-scene.scene-3'), 0),
				opacity: 1,
				duration: 100,
				ease: 'power1',
				delay: 0.4,
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '0%',
				},
				duration: 100,
				ease: 'power1',
			});
	} else {
		tl2.fromTo('.customHeight-7 .phone-bg', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			y: percentToPixel($('.customHeight-18 .main-sdk-platform'), -30),
			duration: 40,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).to('.customHeight-7 ._delay', {
			css: {
				width: '50%',
			},
			duration: 40,
			ease: 'power1',
		})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-1').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '100%',
				},
				duration: 20,
				ease: 'power1',
			})
			.set('.customHeight-7 .sdk-payment__masterCard', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-5').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '50%',
				},
				duration: 20,
				ease: 'power1',
			})
			.set('.customHeight-7 .sdk-payment__tinkoff', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-6').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.to($('.customHeight-7 .line'), {
				opacity: 1,
				duration: 100,
				ease: 'power1',
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-2').find('span'), {
				autoAlpha: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.customHeight-7 .scene-form__input-text.animText-4').find('span'), {
				autoAlpha: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.customHeight-7 .scene-form__btn.main-btn'), {
				opacity: 0.5,
				duration: 100,
				ease: 'power1',
			}, {
				opacity: 1,
				duration: 100,
				ease: 'power1',
			})
			.set('.customHeight-7 .sdk__panel-bottom-click.el-1', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-7 .scene-2 .scene-form__btn.main-btn', {
				backgroundColor: '#185ae0',
				duration: 100,
				ease: 'power1',
				transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
			})
			.set('.customHeight-7 .scene-2 .scene-form__btn.main-btn .ruble-blue', {
				opacity: '0',
				transition: 'opacity 0.3s ease-in-out 0.3s',
			})
			.set('.customHeight-5 .scene-2 .scene-form__btn.main-btn .ruble', {
				opacity: '1',
				transition: 'opacity 0.3s ease-in-out 0.3s',
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '100%',
				},
				duration: 100,
				ease: 'power1',
			})
			.set('.customHeight-7 .phone-scene.scene-3', {
				x: percentToPixel($('.phone-scene.scene-3'), 0),
				opacity: 1,
				duration: 100,
				ease: 'power1',
				delay: 0.4,
			})
			.to('.customHeight-7 ._delay', {
				css: {
					width: '0%',
				},
				duration: 100,
				ease: 'power1',
			});
	}
}

function widgetGsapBlock4() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-8',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	tl1.fromTo('.customHeight-8 .phone-bg.el-1', {
		duration: 100,
		ease: 'power1',
		css: {
			opacity: 0,
			transform: 'translate(-50%, 0) scale(0.6)',
		},
	}, {
		duration: 100,
		ease: 'power1',
		css: {
			opacity: 1,
			transform: 'translate(-50%, 0) scale(1)',
		},
	}).fromTo('.customHeight-8 .phone-bg.el-2', {
		duration: 100,
		ease: 'power1',
		css: {
			opacity: 0,
			transform: 'translate(-50%, 0) scale(0.6)',
		},
	}, {
		duration: 100,
		ease: 'power1',
		css: {
			opacity: 1,
			transform: 'translate(-50%, 0) scale(1)',
		},
	});
}

function widgetGsapBlock5() {
	if ($(window).width() > 1023) {
		let tl1 = gsap.timeline();
		let start = heightHeader * 1.5;

		ScrollTrigger.create({
			trigger: '.customHeight-9',
			toggleActions: 'restart pause reverse  pause',
			start: `0 ${start}`,
			end: 'bottom -150%',
			scrub: 0.3,
			pin: true,
			animation: tl1,
		});

		tl1.fromTo('.customHeight-9 .widget-design__column:nth-child(2) .phone-bg', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-9 .widget-design-left', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			left: '19em',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			left: '0',
			scale: 1,
		}).fromTo('.customHeight-9 .widget-design-right', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			right: '19em',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			right: '0',
			scale: 1,
		}).to('.customHeight-9 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '50%',
			},
		});
	}
}

function widgetGsapBlock6() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-10',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -250%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	if ($(window).width() > 1023) {
		tl1.fromTo('.customHeight-10 .sprite-main-widget', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-exe', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-pay svg:nth-child(1)', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-pay svg:nth-child(2)', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-pay svg:nth-child(3)', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		});
	} else {
		tl1.fromTo('.customHeight-10 .sprite-main-widget', {
			duration: 10,
			opacity: 0,
			ease: 'power1',
			css: {
				right: '-74em',
			},
		}, {
			duration: 10,
			opacity: 1,
			ease: 'power1',
			css: {
				right: '-20em',
			},
		}).fromTo('.customHeight-10 .main-widget-exe', {
			duration: 10,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 10,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-pay img:nth-child(1)', {
			duration: 10,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 10,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-pay img:nth-child(2)', {
			duration: 10,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 10,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.customHeight-10 .main-widget-pay img:nth-child(3)', {
			duration: 10,
			opacity: 0,
			ease: 'power1',
			scale: 0.6,
		}, {
			duration: 10,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		});
	}
}

function sdkGsapBlock1() {
	let tl1 = gsap.timeline();
	let tl2 = gsap.timeline();
	let tl3 = gsap.timeline();
	let tl4 = gsap.timeline();
	let tl5 = gsap.timeline();
	let start = heightHeader * 1.5;

	tl1.to('.sprite-main-sdk-back', {
		y: percentToPixel($('.sprite-main-sdk-back'), -20),
		duration: 5,
		ease: 'power1',
	});

	tl2.to('.sprite-main-sdk-front', {
		y: percentToPixel($('.sprite-main-sdk-front'), -25),
		duration: 5,
		ease: 'power1',
	});

	tl3.to('.customHeight-18 .main-block__title', {
		y: percentToPixel($('.customHeight-18 .main-block__title'), -20),
		duration: 5,
		ease: 'power1',
		opacity: 0,
	});

	tl4.to('.customHeight-18 .main-desc', {
		y: percentToPixel($('.customHeight-18 .main-desc'), -20),
		duration: 5,
		ease: 'power1',
		opacity: 0,
	});

	tl5.to('.customHeight-18 .main-sdk-platform', {
		y: percentToPixel($('.customHeight-18 .main-sdk-platform'), -20),
		x: percentToPixel($('.customHeight-18 .main-sdk-platform'), 5),
		ease: 'power1',
	});

	ScrollTrigger.create({
		trigger: '.customHeight-18',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-18',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl2,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-18',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl3,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-18',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl4,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-18',
		toggleActions: 'restart pause reverse pause',
		start: `0 ${start}`,
		end: 'bottom -150%',
		scrub: 0.3,
		pin: true,
		animation: tl5,
	});
}

function sdkGsapBlock2() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	inputTextAnimation('.sdk-payment__text-anim-el.animText-1');
	inputTextAnimation('.sdk-payment__text-anim-el.animText-2');
	inputTextAnimation('.sdk-payment__text-anim-el.animText-5');
	inputTextAnimation('.sdk-payment__text-anim.animText-3');
	inputTextAnimation('.sdk-payment__text-anim.animText-4');

	tl1.fromTo('.customHeight-19 .phone-bg', {
		duration: 100,
		scale: 0.65,
		ease: 'power1',
	}, {
		duration: 100,
		scale: 1,
		ease: 'power1',
		opacity: 1,
	}).to('.sdk__bg', {
		duration: 100,
		ease: 'power1',
		opacity: 0.6,
	}).to('.sdk__panel-bottom', {
		duration: 100,
		ease: 'power1',
		css: {
			bottom: '0%',
		},
	}).to('.sdk__panel-bottom-delay', {
		duration: 100,
		ease: 'power1',
		css: {
			width: '100%',
		},
	}).set('.sdk__panel-bottom .sdk__panel-bottom-click', {
		duration: 100,
		ease: 'power1',
		css: {
			animationName: 'click_btn',
		},
	})
		.set('.sdk__panel-bottom-btn', {
			duration: 100,
			ease: 'power1',
			css: {
				background: '#000',
				color: '#fff',
				borderColor: '#000',
			},
		})
		.to('.sdk__panel-bottom-delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '0',
			},
		})
		.to('.sdk-payment', {
			duration: 100,
			ease: 'power1',
			css: {
				bottom: 0,
			},
		})
		.to('.sdk-payment__text-placeholder.text-1', {
			duration: 100,
			ease: 'power1',
			css: {opacity: 0},
		})
		.fromTo($('.sdk-payment__text-anim-el.animText-1').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 100,
			stagger: 50,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 100,
			stagger: 50,
		})
		.set('.sdk-payment__masterCard', {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
		.fromTo($('.sdk-payment__text-anim-el.animText-2').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 100,
			stagger: 50,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 100,
			stagger: 50,
		})
		.set('.sdk-payment__tinkoff', {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
		.fromTo($('.sdk-payment__text-anim-el.animText-5').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 100,
			stagger: 50,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 100,
			stagger: 50,
		})
		.to('.sdk-payment__text-placeholder.text-2', {
			duration: 100,
			ease: 'power1',
			css: {opacity: 0},
		})
		.fromTo($('.sdk-payment__text-anim.animText-3').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 100,
			stagger: 50,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 100,
			stagger: 50,
		})
		.to('.sdk-payment__text-placeholder.text-3', {
			duration: 100,
			ease: 'power1',
			css: {opacity: 0},
		})
		.fromTo($('.sdk-payment__text-anim.animText-4').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 100,
			stagger: 50,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 100,
			stagger: 50,
		})
		.to('.sdk__panel-bottom-delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '0%',
			},
		})
		.set('.sdk-payment .sdk__panel-bottom-click', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.sdk-payment__btn', {
			duration: 100,
			ease: 'power1',
			css: {opacity: 1},
		})
		.to('.sdk__panel-bottom-delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '100%',
			},
		})
		.set('.sdk__panel-bottom', {
			duration: 100,
			ease: 'power1',
			css: {
				bottom: '-30%',
			},
		})
		.to('.sdk-payment', {
			duration: 100,
			ease: 'power1',
			css: {
				bottom: '-80%',
			},
		})
		.set('.sdk-loading__box', {
			className: 'sdk-loading__box active',
			duration: 100,
			ease: 'power1',
		})
		.fromTo('.sdk-loading', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
			scale: 0,
		}, {
			duration: 100,
			ease: 'power1',
			opacity: 1,
			scale: 1,
		})
		.to('.sdk-loading__box-circle', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		})
		.to('.sdk-loading__box', {
			duration: 100,
			ease: 'power1',
			css: {
				borderColor: '#1ebe88',
			},
		})
		.fromTo('.sdk-loading__checked', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
			scale: 0,
		}, {
			duration: 100,
			ease: 'power1',
			opacity: 1,
			scale: 1,
		})
		.to('.sdk-loading__text .first', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		})
		.to('.sdk-loading__text .second', {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
		.fromTo('.sdk-loading__btn', {
			duration: 100,
			ease: 'power1',
			css: {
				padding: 0,
				height: 0,
				transform: 'scale(0)',
				opacity: 0,
			},
		}, {
			duration: 100,
			ease: 'power1',
			css: {
				padding: '0.9em 0.5em',
				height: 'auto',
				transform: 'scale(1)',
			},
		})
		.to('.sdk-loading__btn', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		});

	ScrollTrigger.create({
		trigger: '.customHeight-19',
		toggleActions: 'restart pause reverse pause',
		start: `0 ${start}`,
		end: 'bottom -1400%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});
}

function sdkGsapBlock3() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	if ($(window).width() > 501) {
		ScrollTrigger.create({
			trigger: '.customHeight-20',
			toggleActions: 'restart pause reverse pause',
			start: `0 ${start}`,
			end: 'bottom -400%',
			scrub: 0.3,
			pin: true,
			animation: tl1,
		});

		tl1.fromTo('.customHeight-20 .phone-bg', {
			duration: 100,
			ease: 'power1',
			scale: 0.65,
		}, {
			duration: 100,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-1', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-2', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-3', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-1 .sdk__drag', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		}, {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
			.to('.sdk-btn__wrapper.el-1 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-120%',
					top: '100%',
				},
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.sdk-btn__wrapper.el-1 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-250%',
					top: '150%',
				},
			})
			.to('.sdk-btn__wrapper.el-1 .sdk-btn__box .sdk-btn__rectangle', {
				duration: 100,
				ease: 'power1',
				scale: 0.4,
				opacity: 0,
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.set('.sdk-btn__wrapper.el-1 .sdk__drag', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			})
			.set('.sdk-buttons__basket', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '47%',
				},
			})
			.set('.sdk-buttons__pay', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.fromTo('.sdk-btn__wrapper.el-3 .sdk__drag', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			}, {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.to('.sdk-btn__wrapper.el-3 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-120%',
					top: '100%',
				},
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.sdk-btn__wrapper.el-3 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-250%',
					top: '150%',
				},
			})
			.to('.sdk-btn__wrapper.el-3 .sdk-btn__box .sdk-btn__rectangle', {
				duration: 100,
				ease: 'power1',
				scale: 0.4,
				opacity: 0,
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.set('.sdk-btn__wrapper.el-3 .sdk__drag', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			})
			.set('.sdk-buttons__pay', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			})
			.set('.sdk-buttons__googlePay', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.to('.customHeight-20 ._delay', {
				duration: 100,
				ease: 'power1',
				width: '1000px',
				opacity: 0,
			})
			.to('.customHeight-20 ._delay', {
				duration: 100,
				ease: 'power1',
				width: '0',
				opacity: 0,
			});
	} else {
		ScrollTrigger.create({
			trigger: '.customHeight-20',
			toggleActions: 'restart pause reverse pause',
			start: `0 ${start}`,
			end: 'bottom -400%',
			scrub: 0.3,
			pin: true,
			animation: tl1,
		});

		tl1.fromTo('.customHeight-20 .phone-bg', {
			duration: 100,
			ease: 'power1',
			scale: 0.65,
		}, {
			duration: 100,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-1', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-2', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-3', {
			duration: 100,
			opacity: 0,
			ease: 'power1',
			scale: 0,
		}, {
			duration: 100,
			opacity: 1,
			ease: 'power1',
			scale: 1,
		}).fromTo('.sdk-btn__wrapper.el-1 .sdk__drag', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		}, {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
			.to('.sdk-btn__wrapper.el-1 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-120%',
					top: '100%',
				},
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.sdk-btn__wrapper.el-1 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-180%',
					top: '150%',
				},
			})
			.to('.sdk-btn__wrapper.el-1 .sdk-btn__box .sdk-btn__rectangle', {
				duration: 100,
				ease: 'power1',
				scale: 0.4,
				opacity: 0,
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.set('.sdk-btn__wrapper.el-1 .sdk__drag', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			})
			.set('.sdk-buttons__basket', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '47%',
				},
			})
			.set('.sdk-buttons__pay', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.fromTo('.sdk-btn__wrapper.el-3 .sdk__drag', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			}, {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.to('.sdk-btn__wrapper.el-3 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-120%',
					top: '100%',
				},
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.sdk-btn__wrapper.el-3 .sdk-btn__box', {
				duration: 100,
				ease: 'power1',
				css: {
					position: 'absolute',
					right: '-180%',
					top: '150%',
				},
			})
			.to('.sdk-btn__wrapper.el-3 .sdk-btn__box .sdk-btn__rectangle', {
				duration: 100,
				ease: 'power1',
				scale: 0.4,
				opacity: 0,
			})
			.set('.customHeight-20 .phone-bg__bg', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.set('.sdk-btn__wrapper.el-3 .sdk__drag', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			})
			.set('.sdk-buttons__pay', {
				duration: 100,
				ease: 'power1',
				opacity: 0,
			})
			.set('.sdk-buttons__googlePay', {
				duration: 100,
				ease: 'power1',
				opacity: 1,
			})
			.to('.customHeight-20 ._delay', {
				duration: 100,
				ease: 'power1',
				width: '1000px',
				opacity: 0,
			})
			.to('.customHeight-20 ._delay', {
				duration: 100,
				ease: 'power1',
				width: '0',
				opacity: 0,
			});
	}
}

function checkoutGsapBlock1() {
	let tl1 = gsap.timeline();
	let tl2 = gsap.timeline();
	let tl3 = gsap.timeline();
	let tl4 = gsap.timeline();
	let tl5 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-17',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -500%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-17',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -500%',
		scrub: 0.3,
		pin: true,
		animation: tl2,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-17',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -500%',
		scrub: 0.3,
		pin: true,
		animation: tl3,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-17',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -500%',
		scrub: 0.3,
		pin: true,
		animation: tl4,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-17',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -500%',
		scrub: 0.3,
		pin: true,
		animation: tl5,
	});

	tl1.to('.customHeight-17 .sprite-checkout-main-1', {
		y: percentToPixel($('.customHeight-17 .sprite-checkout-main-1'), -15),
		duration: 5,
		ease: 'power1',
	});

	tl2.to('.customHeight-17 .sprite-checkout-main-3', {
		y: percentToPixel($('.customHeight-17 .sprite-checkout-main-3'), -12),
		duration: 5,
		ease: 'power1',
	});

	tl3.to('.customHeight-17 .sprite-checkout-main-2', {
		y: percentToPixel($('.customHeight-17 .sprite-checkout-main-2'), -18),
		duration: 5,
		ease: 'power1',
	});

	tl4.to('.customHeight-17 .main-block__title', {
		y: percentToPixel($('.customHeight-17 .main-block__title'), -20),
		duration: 5,
		ease: 'power1',
		opacity: 0,
	});

	tl5.to('.customHeight-17 .main-desc', {
		y: percentToPixel($('.customHeight-17 .main-desc'), -20),
		duration: 5,
		ease: 'power1',
		opacity: 0,
	});
}

function checkoutGsapBlock2() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-14',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -400%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	if ($(window).width() > 1023) {
		tl1.fromTo('.customHeight-14 .phone-bg', {
			css: {
				top: '24em',
				transform: 'scale(0.9)',
			},
			duration: 5,
			ease: 'power1',
		}, {
			css: {
				top: '7em',
				transform: 'scale(1)',
			},
			duration: 5,
			ease: 'power1',
		}).to('.customHeight-14 .sdk-scene-1', {
			css: {
				top: '-23%',
			},
			duration: 5,
			ease: 'power1',
		}).set('.customHeight-14 .sdk__panel-bottom-click.el-1', {
			duration: 5,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		}).set('.customHeight-14 .checkout-scene-content-1__btn', {
			css: {
				backgroundColor: '#fff',
				color: '#000',
				transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
			},
			duration: 5,
			ease: 'power1',
		})
			.set('.customHeight-14 .checkout__content-el.el-1 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-1 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '10%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .sdk-scene-1', {
				css: {
					opacity: 0,
					transition: 'opacity 0.3s ease-in-out',
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '100%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-14 .sdk-scene-2', {
				css: {
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '50%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-14 .sdk-scene-2', {
				css: {
					top: '-40%',
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .sdk__panel-bottom-click.el-2', {
				duration: 5,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-14 .checkout-scene-content-2__btn', {
				css: {
					backgroundColor: '#fff',
					color: '#000',
					transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '0%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-3 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-3 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .sdk-loading__box', {
				className: 'sdk-loading__box active',
			})
			.to('.customHeight-14 .sdk-scene-3', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '10%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.sdk-loading__box-circle', {
				duration: 5,
				ease: 'power1',
				opacity: 0,
			})
			.to('.customHeight-14 .sdk-loading', {
				duration: 5,
				ease: 'power1',
				opacity: 0,
			})
			.to('.customHeight-14 .checkout-scene__success', {
				duration: 5,
				ease: 'power1',
				opacity: 1,
			});
	} else {
		tl1.fromTo('.customHeight-14 .phone-bg', {
			css: {
				top: '24em',
				transform: 'scale(0.9)',
			},
			duration: 5,
			ease: 'power1',
		}, {
			css: {
				top: '4em',
				transform: 'scale(1)',
			},
			duration: 5,
			ease: 'power1',
		}).to('.customHeight-14 .sdk-scene-1', {
			css: {
				top: '-23%',
			},
			duration: 5,
			ease: 'power1',
		}).set('.customHeight-14 .sdk__panel-bottom-click.el-1', {
			duration: 5,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		}).set('.customHeight-14 .checkout-scene-content-1__btn', {
			css: {
				backgroundColor: '#fff',
				color: '#000',
				transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
			},
			duration: 5,
			ease: 'power1',
		})
			.set('.customHeight-14 .checkout__content-el.el-1 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-1 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '10%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .sdk-scene-1', {
				css: {
					opacity: 0,
					transition: 'opacity 0.3s ease-in-out',
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '100%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-14 .sdk-scene-2', {
				css: {
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '50%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-14 .sdk-scene-2', {
				css: {
					top: '-40%',
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .sdk__panel-bottom-click.el-2', {
				duration: 5,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-14 .checkout-scene-content-2__btn', {
				css: {
					backgroundColor: '#fff',
					color: '#000',
					transition: 'background-color 0.3s ease-in-out 0.3s, color 0.3s ease-in-out 0.3s',
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-2 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 0,
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '0%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-3 .checkout__title', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .checkout__content-el.el-3 .checkout__subTitle', {
				css: {
					top: '-0.8rem',
					opacity: 1,
				},
				duration: 5,
				ease: 'power1',
			})
			.set('.customHeight-14 .sdk-loading__box', {
				className: 'sdk-loading__box active',
			})
			.to('.customHeight-14 .sdk-scene-3', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '10%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.sdk-loading__box-circle', {
				duration: 5,
				ease: 'power1',
				opacity: 0,
			})
			.to('.customHeight-14 .sdk-loading', {
				duration: 5,
				ease: 'power1',
				opacity: 0,
			})
			.to('.customHeight-14 .checkout-scene__success', {
				duration: 5,
				ease: 'power1',
				opacity: 1,
			});
	}
}

function checkoutGsapBlock3() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-15',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -400%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	tl1.fromTo('.customHeight-15 .phone-bg', {
		css: {
			top: '24em',
			transform: 'scale(0.9)',
		},
		duration: 5,
		ease: 'power1',
	}, {
		css: {
			top: '7em',
			transform: 'scale(1)',
		},
		duration: 5,
		ease: 'power1',
	}).fromTo('.customHeight-15 .checkout-scene__store', {
		duration: 5,
		ease: 'power1',
		scale: 0.7,
		opacity: 0,
	}, {
		duration: 5,
		ease: 'power1',
		scale: 1,
		opacity: 1,
	}).fromTo('.customHeight-15 .checkout-form.el-1', {
		duration: 5,
		ease: 'power1',
		opacity: 0,
	}, {
		duration: 5,
		ease: 'power1',
		opacity: 1,
	}).fromTo('.customHeight-15 .checkout-scene__form-inputs', {
		duration: 5,
		ease: 'power1',
		scale: 0.7,
		opacity: 0,
	}, {
		duration: 5,
		ease: 'power1',
		scale: 1,
		opacity: 1,
	}).fromTo('.customHeight-15 .checkout-form.el-3', {
		duration: 5,
		ease: 'power1',
		opacity: 0,
	}, {
		duration: 5,
		ease: 'power1',
		opacity: 1,
	})
		.fromTo('.customHeight-15 .checkout-scene__form-btn', {
			duration: 5,
			ease: 'power1',
			x: '-50%',
			scale: 0.7,
			opacity: 0,
		}, {
			duration: 5,
			ease: 'power1',
			x: '-50%',
			scale: 1,
			opacity: 1,
		})
		.fromTo('.customHeight-15 .checkout-form.el-2', {
			duration: 5,
			ease: 'power1',
			opacity: 0,
		}, {
			duration: 5,
			ease: 'power1',
			opacity: 1,
		});
}

function checkoutGsapBlock4() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-16',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -500%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	if ($(window).width() > 1023) {
		tl1.fromTo('.customHeight-16 .phone-bg', {
			css: {
				top: '24em',
				transform: 'scale(0.9)',
			},
			duration: 5,
			ease: 'power1',
		}, {
			css: {
				top: '5em',
				transform: 'scale(1)',
			},
			duration: 5,
			ease: 'power1',
		}).to('.customHeight-16 .checkout-scene-shop__bottom', {
			css: {
				top: '-28%',
			},
			duration: 5,
			ease: 'power1',
		}).set('.customHeight-16 .sdk__panel-bottom-click.el-1', {
			duration: 5,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		}).set('.customHeight-16 .checkout-scene-shop__btn', {
			duration: 5,
			ease: 'power1',
			css: {
				backgroundColor: '#000',
				transition: '0.3s background-color ease-in-out 0.2s',
			},
		}).set('.customHeight-16 .checkout-scene-shop__icon.el-1', {
			duration: 5,
			ease: 'power1',
			css: {
				opacity: '1',
				transition: '0.3s opacity ease-in-out 0.2s',
			},
		})
			.set('.customHeight-16 .checkout-scene-shop__icon.el-2', {
				duration: 5,
				ease: 'power1',
				css: {
					opacity: '0',
					transition: '0.3s opacity ease-in-out 0.2s',
				},
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '10%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '100%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-16 .checkout-scene-shop__bg', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-16 .checkout-scene-shop__panel-wrapper', {
				css: {
					bottom: '-2em',
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '100%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 .face-id', {
				opacity: 0,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-16 .face-ok', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '0%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-16 .checkout-scene-shop__success', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '0%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '100px',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '0',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '100px',
				},
				duration: 1,
				ease: 'power1',
			});
	} else {
		tl1.fromTo('.customHeight-16 .phone-bg', {
			css: {
				top: '24em',
				transform: 'scale(0.9)',
			},
			duration: 5,
			ease: 'power1',
		}, {
			css: {
				top: '3em',
				transform: 'scale(1)',
			},
			duration: 5,
			ease: 'power1',
		}).to('.customHeight-16 .checkout-scene-shop__bottom', {
			css: {
				top: '-28%',
			},
			duration: 5,
			ease: 'power1',
		}).set('.customHeight-16 .sdk__panel-bottom-click.el-1', {
			duration: 5,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		}).set('.customHeight-16 .checkout-scene-shop__btn', {
			duration: 5,
			ease: 'power1',
			css: {
				backgroundColor: '#000',
				transition: '0.3s background-color ease-in-out 0.2s',
			},
		}).set('.customHeight-16 .checkout-scene-shop__icon.el-1', {
			duration: 5,
			ease: 'power1',
			css: {
				opacity: '1',
				transition: '0.3s opacity ease-in-out 0.2s',
			},
		})
			.set('.customHeight-16 .checkout-scene-shop__icon.el-2', {
				duration: 5,
				ease: 'power1',
				css: {
					opacity: '0',
					transition: '0.3s opacity ease-in-out 0.2s',
				},
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '10%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '100%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-16 .checkout-scene-shop__bg', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-16 .checkout-scene-shop__panel-wrapper', {
				css: {
					bottom: '-2em',
				},
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '100%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 .face-id', {
				opacity: 0,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-16 .face-ok', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-14 .checkout__delay', {
				css: {
					width: '0%',
				},
				duration: 1,
				ease: 'power1',
			})
			.set('.customHeight-16 .checkout-scene-shop__success', {
				opacity: 1,
				duration: 5,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '0%',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '100px',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '0',
				},
				duration: 1,
				ease: 'power1',
			})
			.to('.customHeight-16 ._delay', {
				css: {
					width: '100px',
				},
				duration: 1,
				ease: 'power1',
			});
	}
}

function cabinetGsapBlock1() {
	let tl1 = gsap.timeline();
	let tl2 = gsap.timeline();
	let tl3 = gsap.timeline();
	let tl4 = gsap.timeline();
	let start = heightHeader * 1.5;

	ScrollTrigger.create({
		trigger: '.customHeight-21',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -400%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-21',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -400%',
		scrub: 0.3,
		pin: true,
		animation: tl2,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-21',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -400%',
		scrub: 0.3,
		pin: true,
		animation: tl3,
	});

	ScrollTrigger.create({
		trigger: '.customHeight-21',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -400%',
		scrub: 0.3,
		pin: true,
		animation: tl4,
	});

	tl1.to('.customHeight-21 .sprite-cabinet-main-1', {
		y: percentToPixel($('.customHeight-21 .sprite-cabinet-main-1'), -16),
		duration: 5,
		ease: 'power1',
	});

	tl2.to('.customHeight-21 .sprite-cabinet-main-2', {
		y: percentToPixel($('.customHeight-21 .sprite-cabinet-main-2'), -12),
		duration: 5,
		ease: 'power1',
	});

	tl3.to('.customHeight-21 .main-block__title', {
		y: percentToPixel($('.customHeight-21 .main-block__title'), -20),
		duration: 5,
		ease: 'power1',
		opacity: 0,
	});

	tl4.to('.customHeight-21 .main-desc', {
		y: percentToPixel($('.customHeight-21 .main-desc'), -20),
		duration: 5,
		ease: 'power1',
		opacity: 0,
	});
}

function cabinetGsapBlock4() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	inputTextAnimation('.cabinet-4-1-bottom__input-text.animText-1');

	ScrollTrigger.create({
		trigger: '.customHeight-24',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -800%',
		scrub: 0.1,
		pin: true,
		animation: tl1,
	});

	tl1.fromTo('.customHeight-24 .phone-bg', {
		css: {
			top: '24em',
			transform: 'scale(0.9)',
		},
		duration: 100,
		ease: 'power1',
	}, {
		css: {
			top: '3em',
			transform: 'scale(1)',
		},
		duration: 100,
		ease: 'power1',
	}).to('.customHeight-24 ._delay', {
		duration: 100,
		ease: 'power1',
		css: {
			width: '100%',
		},
	}).set('.customHeight-24 .sdk__panel-bottom-click.el-1', {
		duration: 100,
		ease: 'power1',
		css: {
			animationName: 'click_btn',
		},
	}).set('.customHeight-24 .cabinet-4-1__btn', {
		duration: 100,
		ease: 'power1',
		css: {
			background: '#fff',
			color: '#4297df',
		},
	}).to('.customHeight-24 .phone-bg__bg', {
		duration: 100,
		ease: 'power1',
		css: {
			opacity: 1,
		},
	})
		.to('.customHeight-24 .cabinet-4-1__bottom', {
			duration: 100,
			ease: 'power1',
			css: {
				bottom: '-1em',
			},
		})
		.to('.customHeight-24 .cabinet-4-1-bottom__input-money', {
			duration: 100,
			ease: 'power1',
			css: {
				left: '58%',
			},
		})
		.fromTo($('.cabinet-4-1-bottom__input-text.animText-1').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 50,
			stagger: 25,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 50,
			stagger: 25,
		})
		.set('.cabinet-4-1-bottom__btn.main-btn', {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
		.to('.customHeight-24 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '100%',
			},
		})
		.set('.customHeight-24 .sdk__panel-bottom-click.el-2', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-24 .cabinet-4-1-bottom__btn.main-btn', {
			duration: 100,
			ease: 'power1',
			css: {
				background: '#fff',
				color: '#4297df',
			},
		})
		.to('.customHeight-24 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '0',
			},
		})
		.to('.customHeight-24 .cabinet-4-1__bottom', {
			duration: 100,
			ease: 'power1',
			css: {
				bottom: '-70%',
			},
		})
		.set('.customHeight-24 .sdk-loading__box', {
			duration: 100,
			ease: 'power1',
			className: 'sdk-loading__box active',
		})
		.fromTo('.customHeight-24 .sdk-loading', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
			scale: 0,
		}, {
			duration: 100,
			ease: 'power1',
			opacity: 1,
			scale: 1,
		})
		.to('.customHeight-24 .sdk-loading__box-circle', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		})
		.to('.customHeight-24 .sdk-loading__box', {
			duration: 100,
			ease: 'power1',
			css: {
				borderColor: '#1ebe88',
			},
		})
		.fromTo('.customHeight-24 .sdk-loading__checked', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
			scale: 0,
		}, {
			duration: 100,
			ease: 'power1',
			opacity: 1,
			scale: 1,
		})
		.to('.customHeight-24 .sdk-loading__text .first', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		})
		.to('.customHeight-24 .sdk-loading__text .second', {
			duration: 100,
			ease: 'power1',
			opacity: 1,
		})
		.fromTo('.customHeight-24 .sdk-loading__btn', {
			duration: 100,
			ease: 'power1',
			css: {
				padding: 0,
				height: 0,
				transform: 'scale(0)',
				opacity: 0,
			},
		}, {
			duration: 100,
			ease: 'power1',
			css: {
				padding: '0.9em 0.5em',
				height: 'auto',
				transform: 'scale(1)',
			},
		})
		.to('.customHeight-24 .sdk-loading__btn', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		});
}

function cabinetGsapBlock2() {
	let width = $('.cabinet-2-1-top-lines').width();
	let start = heightHeader * 1.5;
	$('.main-block.customHeight-22 .cabinet-2-1-top .cabinet-2-1-top-line svg').css({
		width,
	});
	let item1 = document.querySelectorAll('.cabinet-2-1-bottom-left__line.el-1 .percent-number');
	let item2 = document.querySelectorAll('.cabinet-2-1-bottom-left__line.el-2 .percent-number');
	let item3 = document.querySelectorAll('.cabinet-2-1-bottom-left__line.el-3 .percent-number');
	let item4 = document.querySelectorAll('.cabinet-2-1-bottom-left__line.el-4 .percent-number');
	let tl1 = gsap.timeline();

	if ($(window).width() > 501) {
		ScrollTrigger.create({
			trigger: '.customHeight-22',
			toggleActions: 'restart pause reverse  pause',
			start: `0 ${start}`,
			end: 'bottom -2600%',
			scrub: 0.1,
			pin: true,
			animation: tl1,
		});

		tl1.fromTo('.customHeight-22 .cabinet-2-1-top__desc', {
			css: {
				opacity: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				opacity: 1,
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-1', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-2', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-3', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-4', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		})
			.fromTo('.customHeight-22 .cabinet-2-1-top-info', {
				css: {
					opacity: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					opacity: 1,
				},
				duration: 100,
				ease: 'power1',
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-1', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#0088ff',
					width: '48.5%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-left', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '48.5%',
					border: '2px solid #fff',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#c0c9d4',
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-1 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '50%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim1')
			.from(item1, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim1')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-1 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-2 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '25%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim2')
			.from(item2, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim2')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-2 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-3 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '15%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim3')
			.from(item3, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim3')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-3 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-4 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '10%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim4')
			.from(item4, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim4')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-4 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-2', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#0088ff',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					border: '2px solid #fff',
					backgroundColor: '#fff',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right .add-widget', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right__icon', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-22 .circle.el-1', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-2', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-3', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-4', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-5', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-6', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 100,
				ease: 'power0',
				css: {
					top: '-30em',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-3', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#0088ff',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#efeeee',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom .add-widget', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom .panel-payment ', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 150,
				ease: 'power0',
				css: {
					top: '-120em',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-4', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.to('.customHeight-22 .panel-payment__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '20%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.main-block.customHeight-22 .panel-payment', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
					transition: 'opacity 0.5s ease-in-out 0.2s',
				},
			})
			.set('.customHeight-22 .panel-payment__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
					transition: 'opacity 0.5s ease-in-out ',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .panel-payment__success', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '80%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '65%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '30%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .panel-payment__success-1', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .panel-payment__success-2', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			});
	} else {
		ScrollTrigger.create({
			trigger: '.customHeight-22',
			toggleActions: 'restart pause reverse  pause',
			start: `0 ${start}`,
			end: 'bottom -2600%',
			scrub: 0.1,
			pin: true,
			animation: tl1,
		});

		tl1.fromTo('.customHeight-22 .cabinet-2-1-top__desc', {
			css: {
				opacity: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				opacity: 1,
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-1', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-2', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-3', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		}).fromTo('.customHeight-22 .cabinet-2-1-top-line.el-4', {
			css: {
				width: 0,
			},
			duration: 100,
			ease: 'power1',
		}, {
			css: {
				width: '100%',
			},
			duration: 100,
			ease: 'power1',
		})
			.fromTo('.customHeight-22 .cabinet-2-1-top-info', {
				css: {
					opacity: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					opacity: 1,
				},
				duration: 100,
				ease: 'power1',
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-1', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#0088ff',
					width: '46.5%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-left', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '46.5%',
					border: '2px solid #fff',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#c0c9d4',
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 100,
				ease: 'power1',
				css: {
					transform: 'translate(40%, 33%) scale(1.8)',
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-1 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '50%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim1')
			.from(item1, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim1')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-1 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-2 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '25%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim2')
			.from(item2, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim2')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-2 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.set('.customHeight-22 .panel-payment__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
					transition: 'opacity 0.3s ease-in-out',
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-3 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '15%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim3')
			.from(item3, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim3')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-3 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.fromTo('.customHeight-22 .cabinet-2-1-bottom-left__line.el-4 .progress', {
				css: {
					width: 0,
				},
				duration: 100,
				ease: 'power1',
			}, {
				css: {
					width: '10%',
				},
				duration: 100,
				ease: 'power1',
			}, 'anim4')
			.from(item4, {
				textContent: 0,
				duration: 100,
				ease: 'power1',
				snap: {textContent: 1},
				stagger: 1,
			}, 'anim4')
			.set('.customHeight-22 .cabinet-2-1-bottom-left__line.el-4 .percent', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 100,
				ease: 'power1',
				css: {
					transform: 'translate(-40%, 33%) scale(1.8)',
				},
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-2', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#0088ff',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right', {
				duration: 100,
				ease: 'power1',
				css: {
					border: '2px solid #fff',
					backgroundColor: '#fff',
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right .add-widget', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.set('.customHeight-22 .cabinet-2-1-bottom-right__icon', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-22 .circle.el-1', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-2', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-3', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-4', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-5', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .circle.el-6', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 100,
				ease: 'power1',
				css: {
					transform: 'translate(0, 0) scale(1)',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 100,
				ease: 'power0',
				css: {
					top: '0em',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-3', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#0088ff',
				},
			})
			.set('.customHeight-22 .panel-payment__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
					transition: 'opacity 0.3s ease-in-out',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom', {
				duration: 100,
				ease: 'power1',
				css: {
					borderColor: '#efeeee',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom .add-widget', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .cabinet-2-4-bottom .panel-payment ', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 .main-block-overflow', {
				duration: 150,
				ease: 'power0',
				css: {
					top: '-40em',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .sdk__panel-bottom-click.el-4', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.to('.customHeight-22 .panel-payment__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '30%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.main-block.customHeight-22 .panel-payment', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
					transition: 'opacity 0.5s ease-in-out 0.2s',
				},
			})
			.set('.customHeight-22 .panel-payment__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
					transition: 'opacity 0.5s ease-in-out ',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .panel-payment__success', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '80%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '65%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '30%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.to('.customHeight-22 .panel-payment__success-1-top .line__bg', {
				duration: 90,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-22 .panel-payment__success-1', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 0,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-22 .panel-payment__success-2', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-22 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			});
	}
}

function cabinetGsapBlock3() {
	let start = heightHeader * 1.5;
	inputTextAnimation('.payment-management-form__text.animText-1');
	inputTextAnimation('.payment-management-form__text.animText-2');
	inputTextAnimation('.payment-management-form__text.animText-3');
	inputTextAnimation('.payment-management-form__text.animText-4');
	inputTextAnimation('.payment-management-form__text.animText-5');

	let tl1 = gsap.timeline();

	ScrollTrigger.create({
		trigger: '.customHeight-23',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -2000%',
		scrub: 0.1,
		pin: true,
		animation: tl1,
	});

	if ($(window).width() > 501) {
		tl1.to('.customHeight-23 .payment-management', {
			css: {
				transform: 'scale(1.7) translate(-20%, 20%)',
			},
			duration: 100,
			ease: 'power1',
		}).set('.customHeight-23 .sdk__panel-bottom-click.el-1', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		}).to('.customHeight-23 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '100%',
			},
		}).to('.customHeight-23 .payment-management', {
			css: {
				transform: 'scale(1) translate(0, 0)',
			},
			duration: 100,
			ease: 'power1',
		}).set('.customHeight-23 .phone-bg__bg', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		})
			.set('.customHeight-23 .payment-management-form', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-23 .desktop-device__wrapper', {
				css: {
					transform: 'scale(1.45)',
				},
				duration: 100,
				ease: 'power1',
			})
			.fromTo($('.payment-management-form__text.animText-1').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-2').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 50,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-3').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-4').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-5').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.set('.customHeight-23 .sdk__panel-bottom-click.el-2', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-23 .payment-management-form__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					backgroundColor: '#fff',
					color: '#4297DF',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-23 .desktop-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-23 .loading-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-23 .loading-device-blue__wrapper', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-23 .loading-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-23 .mobile-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-23 .push-message', {
				duration: 100,
				ease: 'power1',
				css: {
					top: '-0.5em',
					opacity: '1',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-23 .sdk__panel-bottom-click.el-3', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.to('.customHeight-23 .push-message', {
				duration: 100,
				ease: 'power1',
				css: {
					top: '-6em',
					opacity: '0',
					transition: 'opacity 0.3s ease-in-out 0.3s, 0.3s top ease-in-out 0.3s',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-23 .check-payment', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-23 .sdk__panel-bottom-click.el-4', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-23 .check-payment__btn.apple', {
				duration: 100,
				ease: 'power1',
				css: {
					backgroundColor: '#f6f9fe',
					borderColor: '#c1c9d3',
					transition: 'background-color 0.3s ease-in-out 0.15s, color 0.3s ease-in-out 0.15s',
				},
			})
			.set('.customHeight-23 .check-payment__btn.apple .applePay', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
					transition: 'opacity 0.3s ease-in-out 0.15s',
				},
			})
			.set('.customHeight-23 .check-payment__btn.apple .applePay-black', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
					transition: 'opacity 0.3s ease-in-out 0.15s',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-23 .check-payment__container', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
					transition: 'opacity 0.3s ease-in-out 0.2s',
				},
			})
			.set('.customHeight-23 .check-payment__success', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
					transition: 'opacity 0.3s ease-in-out 0.4s',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			});
	} else {
		tl1.to('.customHeight-23 .payment-management', {
			css: {
				transform: 'scale(1.7) translate(-30%, 20%)',
			},
			duration: 100,
			ease: 'power1',
		}).set('.customHeight-23 .sdk__panel-bottom-click.el-1', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		}).to('.customHeight-23 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '100%',
			},
		}).to('.customHeight-23 .payment-management', {
			css: {
				transform: 'scale(1) translate(0, 0)',
			},
			duration: 100,
			ease: 'power1',
		}).set('.customHeight-23 .phone-bg__bg', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		})
			.set('.customHeight-23 .payment-management-form', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: 1,
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-23 .desktop-device__wrapper', {
				css: {
					transform: 'scale(1.15)',
				},
				duration: 100,
				ease: 'power1',
			})
			.fromTo($('.payment-management-form__text.animText-1').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-2').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 50,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-3').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-4').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.fromTo($('.payment-management-form__text.animText-5').find('span'), {
				autoAlpha: 0,
				opacity: 0,
				scale: 1,
				duration: 10,
				stagger: 5,
			}, {
				autoAlpha: 1,
				opacity: 1,
				scale: 1,
				duration: 10,
				stagger: 5,
			})
			.set('.customHeight-23 .sdk__panel-bottom-click.el-2', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-23 .payment-management-form__btn', {
				duration: 100,
				ease: 'power1',
				css: {
					backgroundColor: '#fff',
					color: '#4297DF',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-23 .desktop-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-23 .loading-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.to('.customHeight-23 .loading-device-blue__wrapper', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-23 .loading-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '0%',
				},
			})
			.set('.customHeight-23 .mobile-device', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-23 .push-message', {
				duration: 100,
				ease: 'power1',
				css: {
					top: '-0.5em',
					opacity: '1',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			})
			.set('.customHeight-23 .sdk__panel-bottom-click.el-3', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.to('.customHeight-23 .push-message', {
				duration: 100,
				ease: 'power1',
				css: {
					top: '-6em',
					opacity: '0',
					transition: 'opacity 0.3s ease-in-out 0.3s, 0.3s top ease-in-out 0.3s',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-23 .check-payment', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-23 .sdk__panel-bottom-click.el-4', {
				duration: 100,
				ease: 'power1',
				css: {
					animationName: 'click_btn',
				},
			})
			.set('.customHeight-23 .check-payment__btn.apple', {
				duration: 100,
				ease: 'power1',
				css: {
					backgroundColor: '#f6f9fe',
					borderColor: '#c1c9d3',
					transition: 'background-color 0.3s ease-in-out 0.15s, color 0.3s ease-in-out 0.15s',
				},
			})
			.set('.customHeight-23 .check-payment__btn.apple .applePay', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
					transition: 'opacity 0.3s ease-in-out 0.15s',
				},
			})
			.set('.customHeight-23 .check-payment__btn.apple .applePay-black', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
					transition: 'opacity 0.3s ease-in-out 0.15s',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '50%',
				},
			})
			.set('.customHeight-23 .check-payment__container', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '0',
					transition: 'opacity 0.3s ease-in-out 0.2s',
				},
			})
			.set('.customHeight-23 .check-payment__success', {
				duration: 100,
				ease: 'power1',
				css: {
					opacity: '1',
					transition: 'opacity 0.3s ease-in-out 0.4s',
				},
			})
			.to('.customHeight-23 ._delay', {
				duration: 100,
				ease: 'power1',
				css: {
					width: '100%',
				},
			});
	}
}

function cabinetGsapBlock5() {
	let tl1 = gsap.timeline();
	let start = heightHeader * 1.5;

	inputTextAnimation('.cabinet-5-2__date-text.animText-1');
	inputTextAnimation('.cabinet-5-2__textarea-text.animText-2');

	ScrollTrigger.create({
		trigger: '.customHeight-25',
		toggleActions: 'restart pause reverse  pause',
		start: `0 ${start}`,
		end: 'bottom -1400%',
		scrub: 0.3,
		pin: true,
		animation: tl1,
	});

	tl1.fromTo('.customHeight-25 .phone-bg', {
		css: {
			top: '24em',
			transform: 'scale(0.9)',
		},
		duration: 100,
		ease: 'power1',
	}, {
		css: {
			top: '3em',
			transform: 'scale(1)',
		},
		duration: 100,
		ease: 'power1',
	}).to('.customHeight-25 ._delay', {
		duration: 100,
		ease: 'power1',
		css: {
			width: '50%',
		},
	})
		.set('.customHeight-25 .sdk__panel-bottom-click.el-1', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-25 .cabinet-5-1__btn', {
			duration: 100,
			ease: 'power1',
			css: {
				background: '#fff',
				color: '#4297df',
			},
		})
		.set('.customHeight-25 .cabinet-5-2', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		})
		.to('.customHeight-25 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '80%',
			},
		})
		.to('.customHeight-25 .cabinet-5-2__date-placeholder', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		})
		.fromTo($('.cabinet-5-2__date-text.animText-1').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 20,
			stagger: 5,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 20,
			stagger: 5,
		})
		.to('.customHeight-25 .cabinet-5-2__textarea-placeholder', {
			duration: 100,
			ease: 'power1',
			opacity: 0,
		})
		.fromTo($('.cabinet-5-2__textarea-text.animText-2').find('span'), {
			autoAlpha: 0,
			opacity: 0,
			scale: 1,
			duration: 20,
			stagger: 5,
		}, {
			autoAlpha: 1,
			opacity: 1,
			scale: 1,
			duration: 20,
			stagger: 5,
		})
		.set('.customHeight-25 .sdk__panel-bottom-click.el-2', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-25 .cabinet-5-2__btn', {
			duration: 100,
			ease: 'power1',
			css: {
				background: '#fff',
				color: '#4297df',
			},
		})
		.to('.customHeight-25 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '50%',
			},
		})
		.set('.customHeight-25 .cabinet-5-3', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		})
		.to('.customHeight-25 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '80%',
			},
		})
		.set('.customHeight-25 .sdk__panel-bottom-click.el-3', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-25 .cabinet-5-4', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		})
		.to('.customHeight-25 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '0%',
			},
		})
		.set('.customHeight-25 .sdk__panel-bottom-click.el-4', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-25 .cabinet-5-5', {
			duration: 100,
			ease: 'power1',
			css: {
				opacity: 1,
			},
		})
		.to('.customHeight-25 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '50%',
			},
		})
		.set('.customHeight-25 .sdk__panel-bottom-click.el-5', {
			duration: 100,
			ease: 'power1',
			css: {
				animationName: 'click_btn',
			},
		})
		.set('.customHeight-25 .cabinet-5-5__stars-full-wrapper', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '21.5em',
				transition: 'opacity 0.3s ease-in-out, width 0.3s ease-in-out 0.15s',
			},
		})
		.to('.customHeight-25 ._delay', {
			duration: 100,
			ease: 'power1',
			css: {
				width: '00%',
			},
		});
}

function setCookie(name, value, days) {
	let date; let
		expires;
	if (days) {
		date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	} else {
		expires = '';
	}
	document.cookie = `${name}=${value}${expires}; path=/`;
}

function getCookie(name) {
	/*eslint-disable */
	let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
	return matches ? decodeURIComponent(matches[1]) : undefined;
	/* eslint-enable */
}

function initMaskPhone() {
	if ($('.js-phoneMask').length) {
		$('.js-phoneMask').inputmask({
			mask: '+9 999 999 99 99',
			placeholder: '',
			// mask: '+9{1,13}',
			// mask: '+99999999999',
			showMaskOnHover: false,
		});
	}
}

function acceptCookies() {
	if ($('.popup-aside__btn').length) {
		$('.popup-aside__btn').on('click', () => {
			// $('.popup-aside').addClass('close');
			$('.popup-aside').removeClass('cookie-visible');
			setCookie('CookiesAccepted', Date.now(), 365);
		});
	}
}

$(document).ready(() => {
	AOS.init({
		once: true,
		duration: 800,
	});
	validate();
	acceptCookies();

	let isCookied = getCookie('CookiesAccepted');
	if (!isCookied) {
		$('#popupCookies').addClass('cookie-visible');
	}

	(function init100vh() {
		function setHeight() {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		setHeight();
		window.addEventListener('resize', setHeight);
	})();

	$('body').on('click', '.anchor', function (e) {
		e.preventDefault();
		let target = $($(this).attr('href'));

		if (target.length) {
			let scrollTo = target.offset().top - $('.header__wrapper').height() * 2;
			$('body, html').animate({
				scrollTop: `${scrollTo}px`,
			}, 800);
		}
	});
	let hash = location.hash;
	if ($(hash).length) {
		let target = $(hash);
		setTimeout(() => {
			let scrollTo = target.offset().top - $('.header__wrapper').height() * 2;
			$('body, html').animate({
				scrollTop: `${scrollTo}px`,
			}, 800);
		}, 1000);
	}

	gsap.registerPlugin(ScrollTrigger);

	hamburgerToggle();
	initMaskPhone();

	let width = $(window).width();
	if (width < 1023) {
		ScrollTrigger.config({
			autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load', // notice "resize" is not in the list
		});
	}

	if ($('main').hasClass('widget-page')) {
		if (width < 1023) {
			const swiperDesign = new Swiper('.slider-design', {
				slidesPerView: 1,
				initialSlide: 1,
				loop: false,
				loopAdditionalSlides: 30,
				centeredSlides: true,
				breakpoints: {
					320: {
						slidesPerView: 1,
					},
					1023: {
						slidesPerView: 1,
					},
				},
			});
			console.log(swiperDesign);
		}

		widgetGsapBlock1();
		widgetGsapBlock2();
		widgetGsapBlock3();
		widgetGsapBlock4();
		widgetGsapBlock5();
		widgetGsapBlock6();
		const swiperTariffs = new Swiper('.tariff', {
			slidesPerView: 3,
			centeredSlides: true,
			roundLengths: true,
			loop: true,
			loopAdditionalSlides: 30,
			breakpoints: {
				320: {
					slidesPerView: 1,
					allowTouchMove: true,
				},
				501: {
					slidesPerView: 2,
					allowTouchMove: true,
				},
				1024: {
					slidesPerView: 3,
					allowTouchMove: false,
				},
			},
		});
		console.log(swiperTariffs);

		const swiperLanguage = new Swiper('.slider-language', {
			slidesPerView: 7,
			centeredSlides: true,
			roundLengths: true,
			slideToClickedSlide: true,
			loopPreventsSlide: true,
			allowTouchMove: false,
			loop: true,
			autoplay: {
				delay: 1500,
			},
			loopAdditionalSlides: 30,
			breakpoints: {
				320: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 7,
				},
			},
		});

		const swiperLocalization = new Swiper('.slider-localization', {
			slidesPerView: 1,
			roundLengths: true,
			centeredSlides: true,
			loop: true,
			allowTouchMove: false,
			loopAdditionalSlides: 30,
			speed: 1000,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		});

		swiperLanguage.controller.control = swiperLocalization;
		console.log(swiperLanguage + swiperLocalization);
	} else if ($('main').hasClass('checkout-page')) {
		const swiperTariffs = new Swiper('.tariff', {
			slidesPerView: 3,
			centeredSlides: true,
			roundLengths: true,
			loop: true,
			loopAdditionalSlides: 30,
			breakpoints: {
				320: {
					slidesPerView: 1,
					allowTouchMove: true,
				},
				501: {
					slidesPerView: 2,
					allowTouchMove: true,
				},
				1024: {
					slidesPerView: 3,
					allowTouchMove: false,
				},
			},
		});
		console.log(swiperTariffs);

		checkoutGsapBlock1();
		checkoutGsapBlock2();
		checkoutGsapBlock3();
		checkoutGsapBlock4();
	} else if ($('main').hasClass('sdk-page')) {
		const swiperTariffs = new Swiper('.tariff', {
			slidesPerView: 3,
			centeredSlides: true,
			roundLengths: true,
			loop: true,
			loopAdditionalSlides: 30,
			breakpoints: {
				320: {
					slidesPerView: 1,
					allowTouchMove: true,
				},
				501: {
					slidesPerView: 2,
					allowTouchMove: true,
				},
				1024: {
					slidesPerView: 3,
					allowTouchMove: false,
				},
			},
		});
		console.log(swiperTariffs);

		sdkGsapBlock1();
		sdkGsapBlock2();
		sdkGsapBlock3();
	} else if ($('main').hasClass('cabinet-page')) {
		cabinetGsapBlock1();
		cabinetGsapBlock2();
		cabinetGsapBlock3();
		cabinetGsapBlock4();
		cabinetGsapBlock5();

		const swiperTariffs = new Swiper('.tariff', {
			slidesPerView: 3,
			centeredSlides: true,
			roundLengths: true,
			loop: true,
			loopAdditionalSlides: 30,
			breakpoints: {
				320: {
					slidesPerView: 1,
					allowTouchMove: true,
				},
				501: {
					slidesPerView: 2,
					allowTouchMove: true,
				},
				1024: {
					slidesPerView: 3,
					allowTouchMove: false,
				},
			},
		});
		console.log(swiperTariffs);
	}
});
